/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'graph biometric': {
    width: 16,
    height: 16,
    viewBox: '0 0 66.5 66.5',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M66.5 66H.5V0"/><path pid="1" class="cls-1" d="M11.71 52.07l14.43-20.3 16.82 14.58 13-26.12"/><path pid="2" class="cls-2" d="M21 15.39a10.48 10.48 0 0 0 2-3.19A3.94 3.94 0 0 0 19.48 7a4 4 0 0 0-3.74 2A4 4 0 0 0 12 7a3.94 3.94 0 0 0-3.57 5.2c.26.76 1.51 3.84 7.22 7.89.87-.62 1.64-1.21 2.32-1.77"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/graph biometric.js